export const usuarioModais = {
  cadastroUsuario: 'cadastroUsuario',
  visualizacaoUsuario: 'visualizacaoUsuario',
};
